import globalTheme, { muiTheme } from '../../global'

const Input = {
	MuiFormControl: {
		defaultProps: {
			margin: 'none',
		},
	},
	MuiInputLabel: {
		styleOverrides: {
			root: {
				color: globalTheme.palette.grey.main,
				fontSize: muiTheme.typography.pxToRem(12),
				marginBottom: '7px',
				letterSpacing: '0.2px',
				position: 'relative',
				transform: 'none',
				lineHeight: globalTheme.spacing(2),
				textAlign: 'left',
				zIndex: 0,
				'&.Mui-disabled': {
					color: globalTheme.palette.grey.light,
				},
			},
		},
	},
	MuiInputBase: {
		styleOverrides: {
			input: {
				color: globalTheme.palette.primary.main,
				fontSize: muiTheme.typography.pxToRem(14),
				'&::placeholder': {
					color: globalTheme.palette.grey.medium,
					opacity: 1,
				},
				'&:-ms-input-placeholder': {
					color: globalTheme.palette.grey.medium,
				},
				'&::-ms-input-placeholder': {
					color: globalTheme.palette.grey.medium,
				},
				'&.Mui-disabled': {
					WebkitTextFillColor: globalTheme.palette.grey.medium,
				},
				'&::-webkit-inner-spin-button': {
					opacity: 0,
					display: 'none',
				},
				'&::-webkit-outer-spin-button': {
					opacity: 0,
					display: 'none',
				},
			},
			root: {
				'&.MuiInputBase-adornedStart': {
					paddingLeft: globalTheme.spacing(3),
				},
				'&.MuiInputBase-adornedEnd': {
					paddingRight: globalTheme.spacing(3),
				},
				'&.MuiOutlinedInput-root': {
					color: globalTheme.palette.primary.main,
				},
				'&.Mui-disabled': {
					'.MuiIconButton-root': {
						backgroundColor: 'transparent',
					},
				},
			},
		},
	},
	MuiOutlinedInput: {
		styleOverrides: {
			input: {
				padding: '21px 24px',
				height: '18px',
			},
			root: {
				'& .MuiInputAdornment-root': {
					marginRight: '0',
					color: globalTheme.palette.grey.medium,
				},
				'&:hover:not(.Mui-error):not(.Mui-focused)': {
					'& .MuiOutlinedInput-notchedOutline': {
						borderColor: globalTheme.palette.grey.medium,
					},
				},
				'&.Mui-focused': {
					'& .MuiOutlinedInput-notchedOutline': {
						borderWidth: '1px',
						borderColor: globalTheme.palette.primary.main,
					},
					'&.Mui-error .MuiOutlinedInput-notchedOutline': {
						borderWidth: '1px',
						borderColor: globalTheme.palette.error.main,
					},
					'& .MuiInputAdornment-root': {
						color: globalTheme.palette.primary.main,
						'& .MuiIconButton-root': {
							color: 'inherit',
						},
					},
				},
				'&.Mui-disabled': {
					opacity: 0.4,
					backgroundColor: globalTheme.palette.grey.light,

					'& .MuiOutlinedInput-notchedOutline': {
						borderColor: globalTheme.palette.grey.medium,
					},
					'& .MuiInputAdornment-root': {
						color: globalTheme.palette.grey.medium,
						'& .MuiIconButton-root': {
							color: 'inherit',
						},
					},
				},
				'& .MuiAutocomplete-input': {
					padding: '21px 24px',
				},
			},
			notchedOutline: {
				top: 0,
				borderColor: globalTheme.palette.grey.light,
				borderWidth: '1px',
				'& legend': {
					display: 'none',
				},
			},
		},
	},
	MuiAutocomplete: {
		styleOverrides: {
			root: {
				'& .MuiOutlinedInput-root': {
					backgroundColor: globalTheme.palette.background.paper,
					padding: globalTheme.spacing(0, 0, 0, 3),
					'& .MuiAutocomplete-input': {
						padding: globalTheme.spacing('21px', 3),
					},
					'& .MuiAutocomplete-endAdornment': {
						right: globalTheme.spacing(3),
					},
				},
			},
			hasPopupIcon: {
				'&.MuiAutocomplete-root .MuiOutlinedInput-root': {
					paddingRight: 0,
					'&.MuiInputBase-adornedEnd': {
						paddingRight: globalTheme.spacing(3),
					},
				},
			},
			hasClearIcon: {
				'&.MuiAutocomplete-root .MuiOutlinedInput-root': {
					paddingRight: 0,
					'& .MuiAutocomplete-input': {
						padding: globalTheme.spacing('21px', 8, '21px', 3),
					},
					'& .MuiIconButton-root': {
						color: globalTheme.palette.primary.main,
					},
				},
				'& .MuiAutocomplete-endAdornment .MuiIconButton-root.MuiAutocomplete-clearIndicator': {
					visibility: 'visible',
				},
			},
			clearIndicator: {
				color: globalTheme.palette.grey.medium,
				'& .MuiSvgIcon-root': {
					color: globalTheme.palette.grey.medium + '!important',
				},
			},
			listbox: {
				...globalTheme.scrollbarJsx,
				backgroundColor: globalTheme.palette.background.paper,
				border: '1px solid ' + globalTheme.palette.grey.light,
				borderRadius: globalTheme.shape.borderRadius,
				padding: 0,
				marginTop: '6px',
				'& .MuiAutocomplete-option': {
					padding: '14px 24px',
					borderBottom: '1px solid ' + globalTheme.palette.grey.light,
					'&:last-of-type': {
						borderBottom: 0,
					},
				},
			},
			paper: {
				backgroundColor: 'transparent',
			},
			noOptions: {
				backgroundColor: globalTheme.palette.background.paper,
				color: globalTheme.palette.primary.main,
				border: '1px solid ' + globalTheme.palette.grey.light,
				borderRadius: globalTheme.shape.borderRadius,
				marginTop: '6px',
			},
		},
	},

	MuiFilledInput: {
		styleOverrides: {
			input: {
				padding: '21px 24px',
				height: '18px',
			},
			colorWhite: {
				color: globalTheme.palette.primary.main,
				backgroundColor: globalTheme.palette.white.main,
				borderRadius: globalTheme.shape.borderRadius,
				'&:hover': {
					backgroundColor: globalTheme.palette.white.main,
				},
				'&.Mui-focused': {
					backgroundColor: globalTheme.palette.white.main,
				},
				'&::before': {
					display: 'none',
				},
				'&::after': {
					display: 'none',
				},
			},
		},
	},
}
export default Input
